import { makeStyles, Theme } from '@material-ui/core';
import { style } from 'commons/constants/KeyFlowConstants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 20px',
    height: '85px',
    color: '#ffffff',
    [theme.breakpoints.down('md')]: {
      // margin: '0 0 28px 0',
      padding: '0 15px 28px 15px',
      height: 'auto',
      borderBottom: `1px solid ${style.SCRIPT_DIVIDER_BORDER}`,
    },
  },
  searchKeywordContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
    // justifyContent: 'center',
  },
  searchButton: {
    height: '40px',
    backgroundColor: style.PINK_COLOR,
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '1.0em',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'rgba(202, 90, 150, 0.9)',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
      height: '36px',
    },
  },
  searchMobileButton: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'inline-block',
      height: '36px',
      padding: '7px',
      backgroundColor: style.PINK_COLOR,
      outline: 'none',
      border: '0px',
    },
  },
  searchIcon: {
    height: '100%',
  },
  searchKeywordSelectContainer: {
    position: 'relative',
    zIndex: 10,
    width: '100%',
    height: '36px',
    display: 'flex',
    gap: '16px',
  },
  searchKeywordSelectTrigger: {
    width: '100%',
    height: '36px',
    outline: 'none',
    border: '0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: '#ffffff',
  },
  selectedItem: {
    backgroundColor: '#D94F98',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#D94F98',
      color: '#ffffff',
    },
  },
  searchKeywordSelect: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#ffffff',
    padding: '8px',
  },
  searchKeywordSelectValue: {
    paddingLeft: '4px',
    paddingRight: '16px',
    color: '#000000',
    cursor: 'pointer',
  },

  searchKeywordSelectItem: {
    width: '100%',
    height: '32px',
    paddingLeft: '4px',
    paddingRight: '16px',
    color: '#000000',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  isHideTeamInfo: {
    color: '#727272',
    cursor: 'not-allowed',
  },
  searchKeywordSelectArrow: {
    fontSize: '32px',
    color: style.PINK_COLOR,
  },
  defaultItem: {
    color: '#727272',
  },
  teamItem: {
    justifyContent: 'center',
    color: '#ffffff',
    cursor: 'default',
  },
  teamDefaultItem: {
    backgroundColor: '#696969',
  },
}));

export default useStyles;
